import { render, staticRenderFns } from "./contract-protect-personal-nl.vue?vue&type=template&id=b3b0a2b0&scoped=true"
import script from "./contract-protect-personal-nl.vue?vue&type=script&lang=js"
export * from "./contract-protect-personal-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=b3b0a2b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b0a2b0",
  null
  
)

export default component.exports